import React from 'react';

interface TimerProps {
  timestamp: number;
}

export const Timer: React.FC<TimerProps> = ({ timestamp }) => {
  const zeroPad = (num: number, places: number) => String(num).padStart(places, '0');

  const seconds = Math.floor((timestamp / 1000) % 60);
  const minutes = Math.floor((timestamp / 1000 / 60) % 60);
  const hours = Math.floor((timestamp / (1000 * 60 * 60)) % 24);

  return (
    <span>
      {zeroPad(hours, 2)}:{zeroPad(minutes, 2)}:{zeroPad(seconds, 2)}
    </span>
  );
};
